import { App, getCurrentInstance } from 'vue'

interface TurboLinksPlugin {
  install(app: App): void
}

const TurboLinksPlugin: TurboLinksPlugin = {
  install(app: App) {
    app.mixin({
      mounted() {
        const instance = getCurrentInstance()
        const element = instance?.proxy?.$el as HTMLElement

        const unmountCallback = (): void => {
          if (instance && element && element.parentNode) {
            app.unmount()
          }
        }

        if (instance && instance.uid === instance.root?.uid) {
          document.addEventListener(
            'turbolinks:before-cache',
            unmountCallback,
            {
              once: true,
            }
          )

          document.addEventListener(
            'turbolinks:before-render',
            unmountCallback,
            {
              once: true,
            }
          )
        }
      },
    })
  },
}

export default TurboLinksPlugin
